import type { ModId } from '../store/types';
import type { ModDef } from './tipos';
import { VIAGENS } from './viagens';
import { OBRAS } from './obras';
import { SAUDE } from './saude';
import { VEICULOS } from './veiculos';
import { FAMILIA } from './familia';
import { MUDANCA } from './mudanca';
import { EVENTOS } from './eventos';
import { FREELANCER } from './freelancer';
import { ALIMENTACAO } from './alimentacao';
import { PLANTAS } from './plantas';
import { LEITURA } from './leitura';
import { PATRIMONIO } from './patrimonio';
import { EMPRESTIMOS } from './emprestimos';
import { PROFESSOR } from './professor';
import { HOSPEDAGEM } from './hospedagem';
import { CONSULTORIO } from './consultorio';
import { NOTAS } from './notas';
import { PORTAL } from './portal';
import { DIARIO } from './diario';
import { CLIENTES } from './clientes';

export const DEFS: Record<ModId, ModDef> = {
  viagens: VIAGENS, obras: OBRAS, saude: SAUDE, veiculos: VEICULOS, familia: FAMILIA, mudanca: MUDANCA, eventos: EVENTOS,
  freelancer: FREELANCER, alimentacao: ALIMENTACAO, plantas: PLANTAS, leitura: LEITURA, patrimonio: PATRIMONIO,
  emprestimos: EMPRESTIMOS, professor: PROFESSOR, hospedagem: HOSPEDAGEM, consultorio: CONSULTORIO, notas: NOTAS, portal: PORTAL, diario: DIARIO, clientes: CLIENTES,
};
